import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { LayoutSidebar, OtherContributorsBreakdown, TipCalcOtherContributorsSidebar } from 'components';
import { MPContent } from 'screens/MakePayment/styles';
import { selectSiteSettings } from 'store/Site';
import { selectCalculatorPaymentSet, selectCalculatorPOSResults, selectCalculatorResults } from 'store/TipCalculator';
import { ICalculatorRules } from 'types';
import { buildContributorSegmentCalculations, calculateTipCalculatorTipDataTotals, getNonRecipientContributors, isVirtualRuleContributor } from 'utils';

interface IOtherContributorsProps {
  currentCalculatorRules: ICalculatorRules;
  pageHeaderContent: React.ReactNode;
  onBack: () => void;
}

const OtherContributors = ({ currentCalculatorRules, onBack, pageHeaderContent }: IOtherContributorsProps) => {
  const posResults = useSelector(selectCalculatorPOSResults());
  const tipCalcResults = useSelector(selectCalculatorResults());
  const { tipCalculatorPercentFee: creditCardFee } = useSelector(selectSiteSettings()) || {};
  const paymentSetDate = useSelector(selectCalculatorPaymentSet())?.date;
  const otherContributorsData = useMemo(() => getNonRecipientContributors(posResults?.data || [], tipCalcResults), [posResults?.data, tipCalcResults]);
  const totals = useMemo(() => calculateTipCalculatorTipDataTotals({ ...posResults, data: otherContributorsData }), [posResults, otherContributorsData]);

  const buildOtherContributorsList = () =>
    otherContributorsData.map((posData) => {
      const calculations = buildContributorSegmentCalculations(posData, tipCalcResults);
      return (
        <OtherContributorsBreakdown
          key={`other-contributors-${posData.provider.employeeId}`}
          calculatorRules={currentCalculatorRules.rules}
          categoryGroups={currentCalculatorRules.categoryGroups}
          creditCardFee={creditCardFee}
          posData={posData}
          calculations={calculations}
          isVirtual={isVirtualRuleContributor(posData, currentCalculatorRules)}
        />
      );
    });

  return (
    <LayoutSidebar
      content={
        <>
          {pageHeaderContent}
          <MPContent data-cy="other-contributors-list">{buildOtherContributorsList()}</MPContent>
        </>
      }
      sidebar={<TipCalcOtherContributorsSidebar businessDate={dayjs(paymentSetDate)} totals={totals} creditCardPercentFee={creditCardFee} onBack={onBack} />}
    />
  );
};

export default OtherContributors;
